import { render, staticRenderFns } from "./rkjzRecord.vue?vue&type=template&id=a1484f0a"
import script from "./rkjzRecord.vue?vue&type=script&lang=js"
export * from "./rkjzRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports